<template>
  <section class="experiences-section">
    <h2 class="section-title">Testimonios</h2>
    
    <div class="row" style="align-items: center;">
      <div class="experiences-container col-lg-12 d-flex flex-wrap justify-content-center">
        <div class="col-lg-4 experience-card dark">
          <p class="description-card">“Pasó de estar perdida a tener una dirección clara.” </p>
          <span class="author">— Martha, mamá de Diana.</span>
        </div>

        <div class="col-lg-4 experience-card dark">
          <p class="description-card">“Rápido, claro y profesional.”</p>
          <span class="author">— José, papá de Frida.</span>
        </div>

        <div class="col-lg-4 experience-card dark">
          <p class="description-card">“Volvimos a hablar del futuro sin discutir.”</p>
          <span class="author">— María, mamá de Luis</span>
        </div>
      </div>
    </div>

    <div class="row">
      <p class="coment">“Acercarte al momento en que todo puede empezar a tener sentido.”</p>
    </div>
    <div class="row" style="display: flex !important; justify-content: center; align-items: center; margin-top: 50px; margin-bottom: 40px;">
      <a
        class="cta-button"
        href="https://api.whatsapp.com/send?phone=5215561461518&text=%C2%A1Quiero%20empezar%20mi%20diagn%C3%B3stico%20gratis!%F0%9F%98%80"
        target="_blank"
        rel="noopener"
      >
        INICIAR CONVERSACIÓN
      </a>

    </div>
  </section>
</template>

<script>
export default {
  name: 'ExperiencesSection'
}
</script>

<style scoped>
.experiences-section {
  width: 100%;
  min-width: 320px;
  padding: 24px 16px;
}

.experience-card h3 {
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 140%;
  margin-bottom: 8px;
}

.rating {
  margin-bottom: 8px;
}

.rating img {
  width: 116px;
  height: 20px;
}

.date {
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 10px;
  line-height: 140%;
  color: #C58911;
  margin-bottom: 8px;
}


.experience-card.light .date {
  color: #787878;
}

@media (max-width: 768px) {
  .experiences-container {
    flex-direction: column;
    align-items: center;
  }

  .experience-card {
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100px; /* Ajusta la altura según lo que necesites */
    min-height: 100px;
  }
  .description-card,
  .author {
    display: block;
    width: 100%;
  }
}

@media (max-width: 768px) {
  .experiences-section {
    padding: 12px 4vw !important;
  }

  .section-title {
    font-size: 22px !important;
    text-align: center;
    margin: 16px 0 !important;
  }

  .experiences-container {
    flex-direction: column !important;
    align-items: center !important;
    gap: 16px !important;
    padding: 0 !important;
  }

  .experience-card {
    width: 95vw !important;
    min-width: 0 !important;
    margin: 12px 0 !important;
    padding: 16px !important;
    font-size: 15px !important;
    text-align: center;
  }

  .description-card {
    font-size: 15px !important;
    padding: 0 4px !important;
  }

  .author {
    font-size: 13px !important;
    display: block;
    margin-top: 8px;
  }

  .coment {
    font-size: 14px !important;
    text-align: center;
    padding: 0 8px;
  }

  .cta-button {
    width: 90vw !important;
    min-width: 120px !important;
    font-size: 14px !important;
    height: 44px !important;
    padding: 0 !important;
  }
}
</style>

